<div
  class="flex flex-col gap-14"
  [style.color]="color() | contentBuilderColor"
>
  <div
    class="relative mx-auto max-w-screen-sm rounded-md border-4"
    [style.borderColor]="color() | contentBuilderColor"
  >
    <input
      type="text"
      [value]="pagerValue().padEnd(pagerSize())"
      readonly
      class="w-full cursor-not-allowed border-none bg-transparent text-center text-6xl font-bold focus:ring-0"
      [style.color]="color() | contentBuilderColor"
      (change)="onInputChange()"
    />
  </div>

  <div class="m-auto grid max-w-xl grid-cols-3 gap-8">
    @for (item of [].constructor(9); track $index; let index = $index) {
      <div
        class="flex h-28 w-28 items-center justify-center rounded-full border-4 font-bold"
        [style.borderColor]="color() | contentBuilderColor"
        (click)="onNumberClick(index + 1)"
      >
        <p class="text-5xl">{{ index + 1 }}</p>
      </div>
    }

    <div
      class="col-start-2 flex h-28 w-28 items-center justify-center rounded-full border-4 font-bold"
      [style.borderColor]="color() | contentBuilderColor"
      (click)="onNumberClick('0')"
    >
      <p class="text-5xl">0</p>
    </div>

    <div
      class="flex h-28 w-28 items-center justify-center rounded-full border-4 font-bold"
      [style.borderColor]="color() | contentBuilderColor"
      (click)="onDeleteClick()"
    >
      <p class="text-5xl">x</p>
    </div>
  </div>
</div>
